(ns hai.ui.components.form.date
  "Form-system adapter for the pure `date-picker`. Use `field` as a field
   component in a `form/component` schema, and reference `Value` as that field's
   sub-schema. The field's value is the picker's selection map (see
   `hai.ui.components.date-picker`)."
  (:require
   [hai.ui.components.date-picker :as date-picker]))

(def Value
  "Sub-schema for a deadline field: the picker's local selection. `:date` absent
   means nothing is picked; `:time` absent means a date-only (all-day) deadline."
  [:maybe
   [:map
    [:date {:optional true} [:maybe [:map [:year :int] [:month :int] [:day :int]]]]
    [:time {:optional true} [:maybe :int]]]])

(defn field
  [{:form.field/keys [current-value set-value!]}]
  [date-picker/date-picker
   {:value current-value
    :on-change set-value!}])
